import { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { Locale } from '../../modules/locale'
import { Font } from '../../constants'

// OLD COMPONENT. NOT USED ANYMORE

export interface LvcLoginModalWrapper {
  show: boolean
}

export class LvcLoginModalWrapper extends MinzeElement {
  modalId = MODALS.LOGIN_MODAL
  private showLoading: boolean = false
  reactive: Reactive = [['show', true]]
  private boundUserIsLoading = this.onUserIsLoading.bind(this)

  onReady(): void | Promise<void> {
    const mainModule = MainModule.getInstance()
    const urlParams = new URLSearchParams(window.location.search)
    const recoveryEmailSent = urlParams.get('recover-password-email-sent')
    const recoveryPasswordSuccess = urlParams.get('recover-password-success')
    const createPasswordSuccess = urlParams.get('create-password-success')
    mainModule.getEE().on('lvc:user_signed_but_not_fully_loaded', this.boundUserIsLoading)

    if (recoveryEmailSent === 'true')
      mainModule.showToastAlert(Locale.getKey('login.passwordRecoveryAlert'))
    if (recoveryPasswordSuccess === 'true')
      mainModule.showToastAlert(Locale.getKey('login.passwordRecoverySuccess'))
    if (createPasswordSuccess === 'true')
      mainModule.showToastAlert(Locale.getKey('login.createPasswordSuccess'))

    this.showLoading = mainModule.getAuth().isSignInWithRedirect()
    this.rerender()

    // If the user is still loading after 1 minute, remove the loading screen
    if (this.showLoading) {
      setTimeout(() => {
        this.showLoading = false
        localStorage.removeItem('signingInWith')
        this.rerender(true)
      }, 60000) // 1 minute
    }
  }

  onDestroy() {
    MainModule.getInstance()
      .getEE()
      .off('lvc:user_signed_but_not_fully_loaded', this.boundUserIsLoading)
  }

  onUserIsLoading(): void {
    this.showLoading = true
    this.rerender()
  }

  goBack = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()

    routing.goToLastPage()
  }

  html = () => {
    if (this.showLoading) {
      return `
				<lvc-account-loading></lvc-account-loading>
			`
    }

    return `
			<lvc-modal
				modal-id="${this.modalId}"
				narrow="true"
				hide-when-logged="true"
				modal-title="${Locale.getKey('login.title')}"
				is-fixed="false"
				background="transparent"
				is-fullscreen-modal-scrollable="true"
			>
				<!--<div slot="lvc-modal-top">
					<lvc-box color="#1E007D" display="flex" alignItems="center" id="link-back">
						<lvc-chevron-left-icon></lvc-chevron-left-icon>
						<lvc-box mt="-4px">
							<lvc-text font-preset="small">${Locale.getKey('general.previous')}</lvc-text>
						</lvc-box>
					</lvc-box>
				</div>-->
				<div slot="lvc-modal-content">
					<lvc-login-modal-content></lvc-login-modal-content>
				</div>
			</lvc-modal>
		`
  }

  css = () => `
    :host {
    
    }
    #link-back {
      cursor: pointer;
    }
  `

  eventListeners: EventListeners = [['#link-back', 'click', this.goBack]]
}
